import request from '../utils/request';

/**
 * Get a list of tenants.
 */
export function queryTenants() {
  const url = '/tenants';
  return request(url);
}

/**
 * Get tenant info by tenant ID.
 *
 * @param {string} tenantId Id of the tenant you want to query
 */
export function queryTenantById(tenantId) {
  const url = `/tenants/${tenantId}`;
  return request(url);
}

/**
 * Create a new tenant.
 *
 * @param {object} data Data of the tenant you want to add
 */
export function createTenant(data) {
  const url = '/tenants';
  return request(url, {
    method: 'POST',
    data,
  });
}

/**
 * Update an existing tenant.
 *
 * @param {string} tenantId Id of the tenant you want to update
 * @param {object} data     Data of the tenant you want to update
 */
export function updateTenant(tenantId, data) {
  const url = `/tenants/${tenantId}`;
  return request(url, {
    method: 'PUT',
    data,
  });
}

/**
 * Delete an existing tenant.
 *
 * @param {string} tenantId     Id of the tenant you want to delete
 */
export function deleteTenant(tenantId) {
  const url = `/tenants/${tenantId}`;
  return request(url, {
    method: 'DELETE',
  });
}


/**
 * Create a user for a tenant.
 *
 * @param {string} tenantId   Tenant ID
 * @param {object} data       Data of the user you want to add
 */
export function createUser(tenantId, data) {
  const url = `/tenants/${tenantId}/users`;

  return request(url, {
    method: 'POST',
    data,
  });
}

/**
 * Delete an existing tenant user.
 *
 * @param {string} tenantId     Id of the tenant
 * @param {string} userId       Id of the user you want to delete
 */
export function deleteUser(tenantId, userId) {
  const url = `/tenants/${tenantId}/users/${userId}`;
  return request(url, {
    method: 'DELETE',
  });
}


/**
 * Update an existing tenant user.
 *
 * @param {string} tenantId     Id of the tenant you want to update
 * @param {string} userId       Id of the user you want to update
 * @param {object} data         Data of the user you want to update
 */
export function updateUser(tenantId, userId, data) {
  const url = `/tenants/${tenantId}/users/${userId}`;
  return request(url, {
    method: 'PUT',
    data,
  });
}



// WEBPACK FOOTER //
// ./src/services/tenantAPI.js